import { InjectionToken, Provider } from '@angular/core';

import { StepRouter } from './step-router';
import { StepperConfig } from './stepper-config';

export const STEPPER_CONFIG = new InjectionToken<StepperConfig>('StepperConfig');

export function provideStepRouter(config: StepperConfig): Provider[] {
	return [
		...config.steps,
		StepRouter,
		{
			provide: STEPPER_CONFIG,
			useValue: config
		}
	];
}
